import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardPublicListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardPublicListController.php
* @route '/api/template-dashboard/public'
*/
const GetTemplateDashboardPublicListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardPublicListController.url(options),
    method: 'get',
})

GetTemplateDashboardPublicListController.definition = {
    methods: ["get","head"],
    url: '/api/template-dashboard/public',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardPublicListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardPublicListController.php
* @route '/api/template-dashboard/public'
*/
GetTemplateDashboardPublicListController.url = (options?: RouteQueryOptions) => {
    return GetTemplateDashboardPublicListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardPublicListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardPublicListController.php
* @route '/api/template-dashboard/public'
*/
GetTemplateDashboardPublicListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardPublicListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardPublicListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardPublicListController.php
* @route '/api/template-dashboard/public'
*/
GetTemplateDashboardPublicListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTemplateDashboardPublicListController.url(options),
    method: 'head',
})

export default GetTemplateDashboardPublicListController